/* ════ THEME ═══════════════════════════════════════════════ */
import { $ } from './dom.js';

function updateThemeBtn(t) { const b = $('theme-btn'); if (b) b.innerHTML = t === 'dark' ? '<span>☀</span>Light mode' : '<span>☾</span>Dark mode'; }

export function initTheme() {
  const t0 = localStorage.getItem('grantt_theme') || 'light';
  document.documentElement.setAttribute('data-theme', t0);
  updateThemeBtn(t0);
  $('theme-btn').addEventListener('click', () => {
    const c = document.documentElement.getAttribute('data-theme');
    const n = c === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', n);
    localStorage.setItem('grantt_theme', n);
    updateThemeBtn(n);
  });
}
